import React from 'react';
import '../../../composants/Skeleton/ContentSkeleton.css';
import './ChiffrageSkeleton.css';

// Skeleton de la page Chiffrage. Il decalque la page REELLE — la banniere, la barre d'outils (bouton
// de creation, menu de reprise large, lien vers la liste), puis le tableau des articles retenus avec
// son bouton d'ajout et sa ligne de total. Les selects de lot et le catalogue inline n'y sont plus :
// ils ne sont plus dans la page non plus.
//
// Le shimmer est mutualise avec ContentSkeleton (classe `.cskel`) : une seule animation dans le
// projet, pas une par page.

const ChiffrageSkeleton: React.FC = () => (
  <div className="chskel" aria-hidden="true" aria-busy="true">
    <span className="cskel chskel-banner" />

    <div className="chskel-toolbar">
      <span className="cskel chskel-btn" />
      {/* Le menu de reprise : large, a la hauteur des boutons (cf. .chiffrage-encours-trigger). */}
      <span className="cskel chskel-select" />
      <span className="cskel chskel-btn" />
    </div>

    <div className="chskel-table">
      <div className="chskel-head">
        {Array.from({ length: 7 }).map((_, i) => (
          <span className="cskel chskel-cell" key={i} />
        ))}
      </div>

      {Array.from({ length: 5 }).map((_, r) => (
        <div className="chskel-row" key={r}>
          {Array.from({ length: 7 }).map((_, i) => (
            <span className="cskel chskel-cell" key={i} />
          ))}
        </div>
      ))}

      <span className="cskel chskel-add" />
    </div>

    <div className="chskel-total">
      <span className="cskel chskel-total-bar" />
    </div>

    <div className="chskel-actions">
      <span className="cskel chskel-btn" />
      <span className="cskel chskel-btn" />
    </div>
  </div>
);

export default ChiffrageSkeleton;
